import React, { useState } from 'react';
import { CarouselIndicators } from 'reactstrap';
import AudioSamplesStyle from './AudioSamples.style';
import { CarouselMindful } from 'View/Component';

import { AudioSampleCourse, AudioSampleSleepAids, AudioSampleLogbook } from './AudioSampleItems';

const itemsCarousel = [
  {
    component: <AudioSampleCourse audioId="sleep-sample-course" />,
    key: 1,
  },
  {
    component: <AudioSampleSleepAids audioId="sleep-sample-aids" />,
    key: 2,
  },
  {
    component: <AudioSampleLogbook audioId="sleep-sample-logbook" />,
    key: 3,
  },
];

export const AudioSamples: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const handleNext = () => {
    if (animating) return;
    const nextIndex = activeIndex === itemsCarousel.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const handlePrevious = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? itemsCarousel.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (index: number) => {
    if (animating) return;
    setActiveIndex(index);
  };

  const handleOnStartAnimation = () => setAnimating(true);
  const handleOnEndAnimation = () => setAnimating(false);

  return (
    <AudioSamplesStyle>
      <CarouselMindful
        items={itemsCarousel}
        activeIndex={activeIndex}
        next={handleNext}
        previous={handlePrevious}
        goToIndex={goToIndex}
        onStartAnimation={handleOnStartAnimation}
        onEndAnimation={handleOnEndAnimation}
      />

      <CarouselIndicators
        items={itemsCarousel}
        activeIndex={activeIndex ?? 0}
        onClickHandler={goToIndex}
        className="audio-samples-indicators"
      />
    </AudioSamplesStyle>
  );
};
